import React, { useState, useEffect } from "react";
import axios from "axios";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import BottomFooter from "../components/BottomFooter";
import ColorInit from "../helper/ColorInit";

const ReturnPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  
const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchPolicy = async () => {
      try {

        const response = await axios.get(`${API_BASE_URL}/return-policy/`);
        setPolicy(response.data);
      } catch (err) {
        setError("Failed to load return policy.");
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, []);

  if (loading) return <p>Loading return policy...</p>;
  if (error) return <p>{error}</p>;
  if (!policy) return <p>No return policy found.</p>;

  return (
      <>
      {/* Color and layout shell */}
      <ColorInit color={true} />
      <HeaderOne category={true} />
      <Breadcrumb title="Return Policy" />
            <section id="main-content" className="wrapper main-wrapper">

    <div className="return-policy">
      {/* Hero Section */}
      <section className="return-policy__hero">
        <div className="return-policy__hero-content">
          <h1 className="return-policy__title">{policy.hero_title}</h1>
          <p className="return-policy__subtitle">{policy.hero_subtitle}</p>
        </div>
      </section>

      <div className="return-policy__container">
        {/* Quick Summary */}
        <section className="return-policy__summary">
          {/* Row 1 */}
          <div className="return-policy__summary-row">
            <div className="return-policy__summary-item">
              <span className={`return-policy__summary-icon ${policy.qs_1_icon}`}></span>
              <div>
                <h3>{policy.qs_1_title}</h3>
                <p>{policy.qs_1_desc}</p>
              </div>
            </div>
            <div className="return-policy__summary-item">
              <span className={`return-policy__summary-icon ${policy.qs_2_icon}`}></span>
              <div>
                <h3>{policy.qs_2_title}</h3>
                <p>{policy.qs_2_desc}</p>
              </div>
            </div>
          </div>
          {/* Row 2 */}
          <div className="return-policy__summary-row">
            <div className="return-policy__summary-item">
              <span className={`return-policy__summary-icon ${policy.qs_3_icon}`}></span>
              <div>
                <h3>{policy.qs_3_title}</h3>
                <p>{policy.qs_3_desc}</p>
              </div>
            </div>
            <div className="return-policy__summary-item">
              <span className={`return-policy__summary-icon ${policy.qs_4_icon}`}></span>
              <div>
                <h3>{policy.qs_4_title}</h3>
                <p>{policy.qs_4_desc}</p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="return-policy__process">
          <h2 className="return-policy__section-title">{policy.how_title}</h2>
          {/* Step 1 & 2 */}
          <div className="return-policy__steps-row">
            <div className="return-policy__step">
              <div className="return-policy__step-icon">
                <span className={policy.hw_1_icon}></span>
              </div>
              <div className="return-policy__step-content">
                <h3 className="return-policy__step-title">{policy.hw_1_title}</h3>
                <p className="return-policy__step-details">{policy.hw_1_desc}</p>
              </div>
            </div>
            <div className="return-policy__step">
              <div className="return-policy__step-icon">
                <span className={policy.hw_2_icon}></span>
              </div>
              <div className="return-policy__step-content">
                <h3 className="return-policy__step-title">{policy.hw_2_title}</h3>
                <p className="return-policy__step-details">{policy.hw_2_desc}</p>
              </div>
            </div>
          </div>
          {/* Step 3 & 4 */}
          <div className="return-policy__steps-row">
            <div className="return-policy__step">
              <div className="return-policy__step-icon">
                <span className={policy.hw_3_icon}></span>
              </div>
              <div className="return-policy__step-content">
                <h3 className="return-policy__step-title">{policy.hw_3_title}</h3>
                <p className="return-policy__step-details">{policy.hw_3_desc}</p>
              </div>
            </div>
            <div className="return-policy__step">
              <div className="return-policy__step-icon">
                <span className={policy.hw_4_icon}></span>
              </div>
              <div className="return-policy__step-content">
                <h3 className="return-policy__step-title">{policy.hw_4_title}</h3>
                <p className="return-policy__step-details">{policy.hw_4_desc}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Detailed Policy Sections */}
        <section className="return-policy__details">
          <h2 className="return-policy__section-title">{policy.section_title}</h2>

          {/* Returns */}
          <div className="return-policy__detail-card">
            <div className="return-policy__detail-header"><h3>Returns</h3></div>
            <div className="return-policy__detail-content"><p>{policy.return_text}</p></div>
          </div>

          {/* Refunds */}
          <div className="return-policy__detail-card">
            <div className="return-policy__detail-header"><h3>Refunds</h3></div>
            <div className="return-policy__detail-content"><p>{policy.refund_text}</p></div>
          </div>

          {/* Replacements */}
          <div className="return-policy__detail-card">
            <div className="return-policy__detail-header"><h3>Replacements</h3></div>
            <div className="return-policy__detail-content"><p>{policy.replace_text}</p></div>
          </div>

          {/* Exclusions & Notes */}
          <div className="return-policy__detail-card">
            <div className="return-policy__detail-header"><h3>{policy.exclusions_title}</h3></div>
            <div className="return-policy__detail-content">
              <ul className="return-policy__list">
                {policy.exclusions_list.split("\r\n").map((item, index) => (
                  <li key={index}>{item.trim()}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Return Shipping Address */}
          <div className="return-policy__detail-card">
            <div className="return-policy__detail-header"><h3>{policy.address_title}</h3></div>
            <div className="return-policy__detail-content">
              <p>{policy.address_intro}</p>
              <div dangerouslySetInnerHTML={{ __html: policy.address_block.replace(/\r\n/g, "<br/>") }} />
            </div>
          </div>

          {/* Turnaround & Timing */}
          <div className="return-policy__detail-card">
            <div className="return-policy__detail-header"><h3>{policy.timing_title}</h3></div>
            <div className="return-policy__detail-content">
              <p>{policy.timing_text}</p>
              <p className="return-policy__note">{policy.timing_highlight}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
     </section>

      <BottomFooter />
    </>
  );
};

export default ReturnPolicy;
